import { mount } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";
import { backgroundSVGAnimation } from "../../../Lib/Animations/BackgroundSvg/animation";

export class SvgBackground implements Component {
  readonly el: HTMLElement;
  readonly parent: HTMLElement;

  constructor(el: HTMLElement, parent: HTMLElement) {
    this.el = el;
    this.parent = parent;
    mount(el);
    this.init();
  }

  private init(): void {
    backgroundSVGAnimation(this.el, this.parent);
  }

  destroy(): void {}
}
